import { render, staticRenderFns } from "./ActionChangeHold.vue?vue&type=template&id=821a46da&lang=html"
import script from "./ActionChangeHold.vue?vue&type=script&lang=js"
export * from "./ActionChangeHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports